// BottomTabNavigation.js
import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { FaHome, FaUser, FaEnvelope, FaShoppingBag } from "react-icons/fa";
import { Badge, Button, Tooltip } from "@mui/material";
import "./HomeTab.scss";

const HomeTab = () => {
  const [activeTab, setActiveTab] = useState("/");
  const [isSticky, setIsSticky] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setActiveTab(location?.pathname);
  }, [location]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 56) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div
      className={`Home_tabMain ${
        isSticky && location.pathname != "/Cateloging" ? "sticky" : ""
      }`}
    >
      <NavLink
        to="/"
        style={styles.tab}
        activeClassName="active"
        onClick={() => handleTabChange("/")}
      >
        <Button
          style={{
            display: "flex",
            flexDirection: "column",
            color: "rgb(102, 102, 102)",
          }}
        >
          <span style={activeTab === "/" ? styles.activeText : styles.text}>
            Home
          </span>
        </Button>
      </NavLink>

      <NavLink
        to="/Crm"
        style={styles.tab}
        activeClassName="active"
        onClick={() => handleTabChange("/Crm")}
      >
        <Button
          style={{
            display: "flex",
            flexDirection: "column",
            color: "rgb(102, 102, 102)",
          }}
        >
          <span style={activeTab === "/Crm" ? styles.activeText : styles.text}>
            CRM
          </span>
        </Button>
      </NavLink>

      <NavLink
        to="/Cateloging"
        style={styles.tab}
        activeClassName="active"
        onClick={() => handleTabChange("/Cateloging")}
      >
        <Button
          style={{
            display: "flex",
            flexDirection: "column",
            color: "rgb(102, 102, 102)",
          }}
        >
          <span
            style={
              activeTab === "/Cateloging" ? styles.activeText : styles.text
            }
          >
            Catalog
          </span>
        </Button>
      </NavLink>

      <NavLink
        to="/Scanner"
        style={styles.tab}
        activeClassName="active"
        onClick={() => handleTabChange("/Scanner")}
      >
        <Button
          style={{
            display: "flex",
            flexDirection: "column",
            color: "rgb(102, 102, 102)",
          }}
        >
          <span
            style={activeTab === "/Scanner" ? styles.activeText : styles.text}
          >
            Scanner
          </span>
        </Button>
      </NavLink>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    position: "fixed",
    top: "55px",
    width: "100%",
    backgroundColor: "white",
    height: "55px",
    // borderTop: "1px solid #ccc",
    zIndex: 111111111111111,
  },
  tab: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textDecoration: "none",
    flex: 1,
    color: "#666",
  },
  icon: {
    marginBottom: "5px",
    fontSize: "20px",
  },
  activeIcon: {
    color: "#7367f0",
    fontSize: "20px",
  },
  text: {
    fontSize: "14px",
    fontWeight: 600,
  },
  activeText: {
    color: "#00a2e1",
    fontSize: "14px",
    paddingBlock: "5px",
    fontWeight: 600,
  },
};

export default HomeTab;
